export const ProfilerAnalyticsEventType = 'PROFILER'

export enum ProfilerAction {
  STARTUP = 'startup',
  WEB_SOCKET_CONNECTION = 'web-socket-connection',
  UPDATE_APP = 'update-app',
  SYNC_ROOMS = 'sync-rooms',
  LOAD_CHAT = 'load-chat',
  LOAD_MORE_MESSAGES = 'load-more-messages',
  UPLOAD = 'upload',
  JOIN_CALL = 'join-call',
  START_CALL = 'start-call',
  REJECT_INCOMING_CALL = 'reject-incoming-call',
  LOAD_SHARED_MEDIA = 'load-shared-media',
  DOWNLOAD = 'download',
}
